import React from "react";
import { Routes, Route,} from "react-router-dom";
import {CredentialVerificationVersionRouter} from "./versions/version-router";
import { CredentialCreate } from "./versions/v1/pages/credential-create";
import { ArchiveSummary } from "./archive/components/pages/archive-summary";

export const CredentialVerificationRouter: React.FC = () => {
  
  return (
    <Routes>
      <Route path="archived/*" element={<ArchiveSummary/>} /> 
      <Route
        path="active/*"
        element={<CredentialVerificationVersionRouter />}
      />
      {/* Route for creating a new credential verification draft */}
      <Route
        path="draft/*"
        element={<CredentialCreate/>}
      />
    </Routes>
  );
};

